import { Fragment, memo } from "react";

import { Transition } from "@headlessui/react";

import { CartDrawerView } from "@cart/CartDrawer/CartDrawer.view";

type CartDrawerAnimationProps = Record<
  "enter" | "enterFrom" | "enterTo" | "leave" | "leaveFrom" | "leaveTo",
  string
>;

type DataGiftNoteStatus = {
  giftButtonText: string;
  giftEditNote: string;
  giftText: string;
};

type CartDrawerBaseProps = CartDrawerAnimationProps & {
  btnAddLabel: string;
  btnCloseLabel: string;
  bundleValueText: string;
  cartDiscountTitle: string;
  cartLinkTo: string;
  cartProductGiftItemButtonEditTextLabel: string;
  cartProductGiftItemButtonTextLabel: string;
  cartProductPage: string;
  cartSpendingGiftButtonTextLabel: string;
  cartSpendingGiftTitleLabel: string;
  dataGiftNoteStatus: DataGiftNoteStatus;
  linkAriaLabel: string;
  subtotalLabel: string;
};

const CartDrawerBase = ({
  btnAddLabel,
  btnCloseLabel,
  bundleValueText,
  cartDiscountTitle,
  cartLinkTo,
  cartProductGiftItemButtonEditTextLabel,
  cartProductGiftItemButtonTextLabel,
  cartProductPage,
  cartSpendingGiftButtonTextLabel,
  cartSpendingGiftTitleLabel,
  dataGiftNoteStatus,
  linkAriaLabel,
  subtotalLabel,
  ...cartDrawerAnimationProps
}: CartDrawerBaseProps) => {
  return (
    <Transition.Child as={Fragment} {...cartDrawerAnimationProps}>
      <CartDrawerView
        btnAddLabel={btnAddLabel}
        btnCloseLabel={btnCloseLabel}
        bundleValueText={bundleValueText}
        cartDiscountTitle={cartDiscountTitle}
        cartLinkTo={cartLinkTo}
        cartProductGiftItemButtonEditTextLabel={
          cartProductGiftItemButtonEditTextLabel
        }
        cartProductGiftItemButtonTextLabel={cartProductGiftItemButtonTextLabel}
        cartProductPage={cartProductPage}
        cartSpendingGiftButtonTextLabel={cartSpendingGiftButtonTextLabel}
        cartSpendingGiftTitleLabel={cartSpendingGiftTitleLabel}
        dataGiftNoteStatus={dataGiftNoteStatus}
        linkAriaLabel={linkAriaLabel}
        subtotalLabel={subtotalLabel}
      />
    </Transition.Child>
  );
};

export const CartDrawer = memo(CartDrawerBase);
